import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import i18n from "./i18n";
import VueEcharts from "vue-echarts";
import * as echarts from "echarts"; // Important for rendering vue charts! Do not remove

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap-icons/font/bootstrap-icons.css"
import "./styles.css"

const app = createApp(App);
app.use(router);
app.use(i18n);
app.component("v-chart", VueEcharts);
app.mount("#app");
